import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { PushNotificationInfo } from 'notifications/push'
import { performAction } from 'shared/queries/perform_action'
import keys from './shared/keys'

type Variables = {
  pushNotificationInfo: PushNotificationInfo
}

export function useMarkPushNotificationRead() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateNotification,
    onSuccess: async () => {
      return client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function updateNotification({
    pushNotificationInfo,
  }: Variables): Promise<void> {
    await performAction(server, pushNotificationInfo.markAsReadAction)
  }
}
